export default __webpack_public_path__ + "static/banner_qiita-4135a9660ef331f7b5ec4ad5a303db2d.png";